
export enum Projection {
  LatLon = 'EPSG:4326',
  WebMercator = 'EPSG:3857',
}
